"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "作品 / 课程名称",
        prop: "workName",
        isShow: true,
        width: "200"
      }, {
        name: "选手名称",
        prop: "userName",
        isShow: true,
        width: "200"
      }
      // {
      //   name: "作品状态",
      //   prop: "workStatus",
      //   isShow: true,
      //   width: "200"
      // }
      ],
      funBtns: [{
        size: "small",
        click: "addWorks",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: " 查看",
        class: "edit",
        option: "view",
        span: 2
      }, {
        name: " 提交作品",
        class: "editor",
        option: "submitWorks",
        span: 4,
        isFuntion: true,
        optionFun: "cszpPd"
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: ""
    };
  },
  methods: {
    cszpPd: function cszpPd(row, callback) {
      if (row.workStatus == -1 || row.workStatus == 0 || row.workStatus == 2) {
        callback(true);
      } else {
        callback(false);
      }
    },
    // 获取学校下作品列表
    schoolStageWorksList: function schoolStageWorksList() {
      var _this = this;
      (0, _school.schoolStageWorksList)({
        groupId: this.$route.query.id,
        stageId: this.$route.query.stageId,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    // 提交作品
    submitWorks: function submitWorks(row) {
      this.$router.push({
        path: "/education/schoolUploadWorks",
        query: {
          id: row.workId,
          stageId: row.stageId,
          matchId: this.$route.query.matchId,
          groupId: this.$route.query.groupId
        }
      });
    },
    //查看
    view: function view(e) {
      console.log(e);
      this.$router.push({
        path: "/education/workDetails",
        query: {
          worksId: e.workId
        }
      });
    },
    // 学校提交作品
    addWorks: function addWorks() {
      this.$router.push({
        path: "/education/schoolUploadWorks",
        query: {
          stageId: this.$route.query.stageId,
          groupId: this.$route.query.groupId,
          matchId: this.$route.query.matchId
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.schoolStageWorksList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageNumber = 1;
      this.page.pageSize = e;
      this.schoolStageWorksList();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.schoolStageWorksList();
  }
};